export class OrganizationBuilder {
    constructor() {
        this.organization = {};
    }

    setId(id){
        this.organization.id = id;
        return this;
    }

    setValue(value){
        this.organization.value = value;
        return this;
    }

    setName(name){
        this.organization.name = name;
        return this;
    }

    setTrendsId(trendsId){
        this.organization.trendsId = trendsId;
        return this;
    }

    build(){
        return this.organization;
    }
}
